import React from  'react';
import { connect } from 'react-redux';
import LeftMenu from 'jd-library/LeftMenu';
import leftMenuActions from "jd-library/leftMenuActions";

const ToggleLeftMenu = (props) => {

   const toggleLeftMenu = (event) => {
        props.showHideLeftMenu(true);
    }

    return(
        <>
        <div className="headerIcon" onClick={toggleLeftMenu}>
            <span className="icon-HDRburger" />
		</div>
        <LeftMenu  fromVendor={true}/>
        </>
    )
};
const showHideLeftMenu = (payload) => {
    return (dispatch) => {
        dispatch(leftMenuActions.showHideLeftMenu(payload));
    };
};
export default connect(null,{showHideLeftMenu})(ToggleLeftMenu);
